import { SVG_BASE_PATH, SVG_ICONS, SVG_SHARE, SVG_REGISTRATION } from 'aria-viewer/tour/constants/'
//puresvg
import exclamation from 'public/assets/svg/icons/raw/icon_error_exclamation.raw.svg'
import socialShare from 'public/assets/svg/icons/raw/icon_social_share.raw.svg'
import vr from 'public/assets/svg/icons/raw/icon_cardboard2.raw.svg'
import accessible from 'public/assets/svg/icons/raw/accessible_icon.raw.svg'
import expand from 'public/assets/svg/icons/raw/icon_expand.raw.svg'
import minimize from 'public/assets/svg/icons/raw/icon_minimize.raw.svg'
import close from 'public/assets/svg/icons/raw/icon_close.raw.svg'
import info_desktop from 'public/assets/svg/icons/raw/icon_info_1.raw.svg'
import closed_captioning from 'public/assets/svg/icons/raw/icon_closed_captioned.raw.svg'
import speaker_on from 'public/assets/svg/icons/raw/icon_speaker_on.raw.svg'
import speaker_off from 'public/assets/svg/icons/raw/icon_speaker_off.raw.svg'
import stopMenu from 'public/assets/svg/icons/raw/icon_submenu.raw.svg'
import edit from 'public/assets/svg/icons/raw/icon_edit_2.raw.svg'
import arrowDropDown from 'public/assets/svg/icons/raw/icon_arrow_drop_down.raw.svg'

//normal svg
import icon_audio_headphones_on from 'public/assets/svg/icons/icon_audio_headphones_on.svg'
import icon_audio_headphones_off from 'public/assets/svg/icons/icon_audio_headphones_off.svg'
import icon_error_exclamation from 'public/assets/svg/icons/icon_error_exclamation.svg'
import icon_edit_2 from 'public/assets/svg/icons/icon_edit_2.svg'
import icon_map2 from 'public/assets/svg/icons/icon_map2.svg'
import icon_plus_2 from 'public/assets/svg/icons/icon_plus_2.svg'
import icon_minus_2 from 'public/assets/svg/icons/icon_minus_2.svg'
import icon_map_arrow from 'public/assets/svg/icons/icon_map_arrow.svg'
import icon_cardboard2 from 'public/assets/svg/icons/icon_cardboard2.svg'
import accessible_icon from 'public/assets/svg/icons/accessible_icon.svg'
import ellipsis from 'public/assets/svg/icons/ellipsis.svg'
import icon_social_share from 'public/assets/svg/icons/icon_social_share.svg'
import icon_share_email from 'public/assets/svg/social/share/icon_share_email.svg'
import icon_share_link from 'public/assets/svg/social/share/icon_share_link.svg'
import icon_share_twitter from 'public/assets/svg/social/share/icon_share_twitter.svg'
import icon_share_linkedin from 'public/assets/svg/social/share/icon_share_linkedin.svg'
import icon_share_facebook from 'public/assets/svg/social/share/icon_share_facebook.svg'
import icon_share_instagram from 'public/assets/svg/social/share/icon_share_instagram.svg'
import icon_menu from 'public/assets/svg/icons/icon_menu.svg'
import icon_submenu from 'public/assets/svg/icons/icon_submenu.svg'
import icon_close from 'public/assets/svg/icons/icon_close.svg'
import icon_confirmation from 'public/assets/svg/icons/icon_confirmation.svg'
import icon_checkmark from 'public/assets/svg/icons/icon_checkmark.svg'
import icon_arrow_drop_down from 'public/assets/svg/icons/icon_arrow_drop_down.svg'
import DropDownCaret from 'public/assets/svg/DropDownCaret.svg'
import icon_next from 'public/assets/svg/icon_next.svg'
import icon_grid_2 from 'public/assets/svg/icons/icon_grid_2.svg'
import icon_info_2 from 'public/assets/svg/icons/icon_info_2.svg'
import icon_info_1 from 'public/assets/svg/icons/icon_info_1.svg'
import icon_expand from 'public/assets/svg/icons/icon_expand.svg'
import icon_minimize from 'public/assets/svg/icons/icon_minimize.svg'
import icon_play_empty from 'public/assets/svg/icons/icon_play_empty.svg'
import icon_more_media from 'public/assets/svg/icons/icon_more_media.svg'
import yv_logo from 'public/assets/svg/yv_logo.svg'
import icon_video_play_transparent from 'public/assets/svg/icons/icon_video_play_transparent.svg'
import icon_video_pause_transparent from 'public/assets/svg/icons/icon_video_pause_transparent.svg'
import icon_volume_on from 'public/assets/svg/icons/icon_volume_on.svg'
import icon_volume_off from 'public/assets/svg/icons/icon_volume_off.svg'
import icon_video_quality_settings from 'public/assets/svg/icons/icon_video_quality_settings.svg'
import icon_speaker_on from 'public/assets/svg/icons/icon_speaker_on.svg'
import icon_speaker_off from 'public/assets/svg/icons/icon_speaker_off.svg'

import registration_email from 'public/assets/svg/registration/registration_mail.svg'
import registration_check from 'public/assets/svg/registration/registration_check.svg'
import registration_stoplight from 'public/assets/svg/registration/registration_stoplight.svg'

const icons = {
    width: '100%',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
}

const ICON_MAP = {
    icon_audio_headphones_on,
    icon_audio_headphones_off,
    icon_error_exclamation,
    icon_edit_2,
    icon_map2,
    icon_plus_2,
    icon_minus_2,
    icon_map_arrow,
    icon_cardboard2,
    accessible_icon,
    ellipsis,
    icon_social_share,
    icon_share_email,
    icon_share_link,
    icon_share_twitter,
    icon_share_linkedin,
    icon_share_facebook,
    icon_share_instagram,
    icon_menu,
    icon_submenu,
    icon_close,
    icon_confirmation,
    icon_checkmark,
    icon_arrow_drop_down,
    DropDownCaret,
    icon_next,
    icon_grid_2,
    icon_info_2,
    icon_info_1,
    icon_expand,
    icon_minimize,
    icon_play_empty,
    icon_more_media,
    yv_logo,
    icon_video_play_transparent,
    icon_video_pause_transparent,
    icon_volume_on,
    icon_volume_off,
    icon_video_quality_settings,
    icon_speaker_on,
    icon_speaker_off,
    registration_email,
    registration_check,
    registration_stoplight,
}

const createIcon = (svg, path = SVG_ICONS) => {
    return Object.assign({}, icons, {
        backgroundImage: ICON_MAP[svg] ? `url('${ICON_MAP[svg]}')` : `url(\"${path}${svg}.svg\")`,
    })
}

export default {
    default: icons,
    audio_on: Object.assign(createIcon('icon_audio_headphones_on'), {
        backgroundSize: '90%',
        backgroundPosition: '50%',
    }),
    audio_off: Object.assign(createIcon('icon_audio_headphones_off'), {
        backgroundSize: '90%',
        backgroundPosition: '50%',
    }),
    exclamation: createIcon('icon_error_exclamation'),
    edit: createIcon('icon_edit_2'),
    map: createIcon('icon_map2'),
    map_plus: createIcon('icon_plus_2'),
    map_minus: createIcon('icon_minus_2'),
    map_arrow: createIcon('icon_map_arrow'),
    vr: createIcon('icon_cardboard2'),
    accessible: createIcon('accessible_icon'),
    ellipsis: createIcon('ellipsis'),
    socialShare: createIcon('icon_social_share'),
    shareEmail: createIcon('icon_share_email', SVG_SHARE),
    shareLink: createIcon('icon_share_link', SVG_SHARE),
    shareTwitter: createIcon('icon_share_twitter', SVG_SHARE),
    shareLinkedin: createIcon('icon_share_linkedin', SVG_SHARE),
    shareFacebook: createIcon('icon_share_facebook', SVG_SHARE),
    shareInstagram: createIcon('icon_share_instagram', SVG_SHARE),
    tourMenu: createIcon('icon_menu'),
    stopMenu: createIcon('icon_submenu'),
    close: createIcon('icon_close'),
    confirmation: createIcon('icon_confirmation'),
    checkmark: createIcon('icon_checkmark'),
    arrowDropDown: createIcon('icon_arrow_drop_down'),
    arrowDown: createIcon('DropDownCaret', SVG_BASE_PATH),
    nextArrow: createIcon('icon_next', SVG_BASE_PATH),
    library: createIcon('icon_grid_2'),
    info: Object.assign(createIcon('icon_info_2'), { backgroundSize: 'cover' }),
    info_desktop: createIcon('icon_info_1'),
    expand: createIcon('icon_expand'),
    minimize: createIcon('icon_minimize'),
    play_empty: createIcon('icon_play_empty'),
    more_media: createIcon('icon_more_media'),
    logo: createIcon('yv_logo', SVG_BASE_PATH),
    videoPlay: createIcon('icon_video_play_transparent'),
    videoPause: createIcon('icon_video_pause_transparent'),
    volumeOn: createIcon('icon_volume_on'),
    volumeOff: createIcon('icon_volume_off'),
    videoSetting: createIcon('icon_video_quality_settings'),
    speaker_on: Object.assign(createIcon('icon_speaker_on'), {
        backgroundSize: '50%',
        backgroundPosition: '50%',
    }),
    speaker_off: Object.assign(createIcon('icon_speaker_off'), {
        backgroundSize: '50%',
        backgroundPosition: '50%',
    }),
    puresvg: {
        exclamation,
        socialShare,
        vr,
        accessible,
        expand,
        minimize,
        close,
        info_desktop,
        closed_captioning,
        speaker_on,
        speaker_off,
        stopMenu,
        edit,
        arrowDropDown,
    },
    registrationMail: createIcon('registration_mail', SVG_REGISTRATION),
    registrationStoplight: createIcon('registration_stoplight', SVG_REGISTRATION),
    registrationCheck: createIcon('registration_check', SVG_REGISTRATION),
}
